<script>
import gql from 'graphql-tag'
import axios from 'axios'
import BaseLayout from '@/components/shared/layout/BaseLayout'
import platformDetect from '@/mixins/platformDetect'
export default {
  name: 'Interview',
  data () {
    return {
      container: null,
      link: null,
      valvid: '',
      inter: '',
      page: '',
      pageCurrent: 1,
      min: 5,
    }
  },
  mixins: [
    platformDetect,
    // getUsagerStatistiques,
  ],
  apollo: {
    page: {
      query: gql `query page($id: String!){
          page(id: $id){
            id page_containers{
              id container{titre id medias{
                id video{
                  url titre description link
                }
              }}
            }
          }
      }`,
      variables () {
        return {id: '863728d0-ed72-4be0-8e94-9fa3f3d70f18'}
      },
      fetchPolicy: 'cache-first',
      update: data => data.page,
    },
  },
  components: {
    BaseLayout,
  },
  computed: {
    interviews () {
      if (this.page.page_containers) {
        return this.page.page_containers
      }
    },
    isMore () {
      if (this.pageCurrent * this.min < this.page.page_containers.length) {
        return true
      } else {
        return false
      }
    },
    isLess () {
      if (this.pageCurrent > 1) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    async getHTML (url) {
      var h = Math.round(document.documentElement.clientHeight * 0.5)
      var w = Math.round(document.documentElement.clientWidth * 0.8)
      try {
        /*eslint-disable*/
        var temp = await axios.get('https://vimeo.com/api/oembed.json?url=' + url + '&width='+ w +'&height=' + h )
        /*eslint-enable*/
      } finally {
        this.valvid = temp.data.html
        this.thumbnail = temp.data.thumbnail_url_with_play_button
      }
    },
    isVimeo: function (url) {
      if (url.includes('vimeo')) {
        this.getHTML(url)
        return true
      } else {
        return false
      }
    },
    test (interview) {
      this.inter = interview.container.medias[0].video.link
      this.$refs.minimezedModal.open()
    },
    showMore () {
      this.pageCurrent ++
    },
    showLess () {
      this.pageCurrent --
    },
    minListe () {
      console.log('TEST')
      if (this.pageCurrent === 1) {
        return 1
      } else {
        return (this.pageCurrent * this.min) - this.min + 1
      }
    },
    maxListe () {
      if (this.pageCurrent === 1) {
        return 5
      } else {
        console.log(this.pageCurrent * this.min)
        return this.pageCurrent * this.min
      }
    },
  },
}
</script>
<template lang="pug">
base-layout
  div.backgroundtexture
  div.backgroundcolor
  div.interview
    q-modal(ref="minimezedModal", minimized,  :content-css="{padding: '-1px', background: 'transparent', width: '90%'}")
      div(v-if="isVimeo(inter)")
        div(v-html='valvid')
      // div(v-else)
        q-video(:src='getVid(inter)', style="height: 300px;")
          q-btn.red(@click='open = false', label='close')
    div.logosection
      //- img(src="~@/assets/The_Film_Button.png", width="200px")
      div.sectiontitre
        span.titretestintro THE <br>
        span.titretest INTERVIEWS
        hr.lignemenu
    div.contentsection
      div.menucontent.fl.flex(v-if='(index >= minListe() && index <= maxListe())', v-for='(p, index) in page.page_containers')
        div.menustyle2
          div.white.pointer(@click='test(p)') {{p.container.titre}}
          // router-link(:to="{name: 'info-interview-show', params: {id: p.container.id} }") {{p.container.titre}}
  div.conteneurboutons
    q-btn.boutonnext.fr.absolute(v-if='isMore', icon-right='fa-caret-right', @click="showMore") Next
    q-btn.boutonlast.fr.absolute(v-if='isLess', icon='fa-caret-left', @click="showLess") Back
      // div.menucontent.fl.flex(v-for='interview in container')
        div.menustyle.inline-flex
          span(@click='test(interview)') {{interview.titre}}
        q-btn.boutonnext.fr.absolute(icon-right='fa-arrow-right', @click="showMore") Next
        q-btn.boutonlast.fr.absolute(icon='fa-arrow-left', @click="showLess") Back
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*ANIMATIONS*/
.backgroundtexture{
  -moz-animation: fadeIn 2;
  -webkit-animation: fadeIn 2s;
  animation: fadeIn 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}

.conteneurboutons{
  -moz-animation: fadeIn 2s 4s;
  -webkit-animation: fadeIn 2s 4s;
  animation: fadeIn 2s 4s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
  }
.logosection{
  -moz-animation: fadeInDown 2s 1s;
  -webkit-animation: fadeInDown 2s 1s;
  animation: fadeInDown 2s 1s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.menucontent{
  -moz-animation: fadeInUp 2s 1s;
  -webkit-animation: fadeInUp 2s 1s;
  animation: fadeInUp 2s 1s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.lignemenu{
  -moz-animation: zoomIn 2s 2s;
  -webkit-animation: zoomIn 2s 2s;
  animation: zoomIn 2s 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
/*ANIMATIONS END*/
.backgroundcolor{
background: linear-gradient(233deg,#8f0000, #e30000, #ff0000);
background-size: 200% 200%;
min-width:100vw;
width:100%;
opacity:0.5;
min-height:100vh;
height:100%;
z-index:-9;
position:absolute;
mix-blend-mode:hard-light;
}
.modal.minimized{
background:rgba(0,0,0,0.8)!important
}
.modal-content{
	-webkit-box-shadow: none !important;
	-moz-box-shadow: none !important;
	box-shadow: none !important;
}
.boutonnext{
  border: solid white 2px!important;
  font-family: Abril Fatface!important;
  /*text-transform: uppercase!important;*/
  font-size: 18px;
  width:110px;
  color:white!important;
  margin-top: 20px!important;
  background-color: rgba(0,0,0,0.3)

}
.boutonlast{
  border: solid white 2px!important;
  font-family: Abril Fatface!important;
  /*text-transform: uppercase!important;*/
  font-size: 18px;
  width:110px;
  color:white!important;
  margin-top: 20px!important;
  background-color: rgba(0,0,0,0.3)
}
@media only screen and (min-width: 320px){
  .backgroundblack{
    background-color: black;
    height: 100vh;
    width:100vw;
    z-index:-11;
    position:fixed;
  }
  .backgroundtexture{
  background-image: url("~@/assets/imgs_bg/fond4.jpg");
  background-size: cover;
  height: 100%;
  min-height: 100vh;
  width:100vw;
  z-index:-10;
  position:absolute;
  }
  .boutonnext{
    right: 10%;
    bottom:0%;


  }
  .boutonlast{
    bottom: 0%;
    left: 10%;

  }
  .borderred{
    width:92vw;
    height: 91vh;
    position:absolute;
    border-style: solid;
    border-width: 3px 3px 3px 3px;
    border-color: red;
  }
  .lignemenu{
    width:60%;
    max-width:500px;
    border-color: white;
    margin-bottom:0px !important;
    margin-top:30px;
    overflow: visible; /* For IE */
    height: 30px;
    border-style: solid;
    border-width: 1px 0 0 0;
    border-radius: 20px;
  }
  .lignemenu:after{
    display: block;
    content: "";
    height: 30px;
    margin-top: -31px;
    border-style: solid;
    border-color: white;
    border-width: 0 0 1px 0;
    border-radius: 20px;
  }
  .interview{
    & .logosection{
      padding-top:20%;
      & .sectiontitre{
        margin-bottom:40px;

        & .titretestintro{
          font-family: Abril Fatface;
          color:white;
          font-size:24px;
          text-align: center;
        }
        & .titretest{
          font-family: Abril Fatface;
          color:white;
          font-size:48px;
          text-align: center;
        }
      }
    }
    & .menucontent{
      width: 100%;
      & .menustyle{
        width: 280px;
        border-style: solid;
        border-width: 0 0 1px 0;
        text-align: left !important;
        border-color: red;
        padding:10px;
        font-family:Marketdeco;
        color: red;
        font-size: 20px;
        margin: 0 auto;
        margin-bottom: 20px;
      }
      & .menustyle2{
        width:200px;
        margin: 20px auto 20px;
        /*line-height:24px;*/
        font-size:24px;
        /*font-family:Marketdeco;*/
        font-family:Barlow Condensed;
        font-weight: 400;
        /*text-transform: uppercase;*/
      }
      & a{
        color:white;
      }
    }
  }
  /* .interview:before{
  content: " ";
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  border: 4px double red;
  } */
}
@media only screen and (min-width: 320px) and (max-width: 767px) and (orientation:landscape) {
.boutonnext{
  right: 55%;
  bottom:3%;

}
.boutonlast{
  bottom: 3%;
  left: 8%;

}
.interview{
  & .titrecontent{
    font-family:Marketdeco;
    color: red;
    font-size: 20px;
    margin-bottom: 30px;
    margin-top: 50px;
    & span{
      border-style: solid;
      border-width: 3px 0 3px 0;
      border-color: red;
      padding: 5px 10px 5px 10px;
    }
  }
  & .logosection{
    float:left;
    width: 45%;
    padding-top: 18%;
    padding-left:10%;
    /*height: 100vh;*/

  }
  & .contentsection{
    float:left;
    width: 50%;
    margin-top: 8%;
    margin-left:5%;
    & .menucontent{
      width: 90%;
      /*margin-top: 10%;*/
    }
  }
}
}
@media only screen and (min-width: 768px){
  .boutonnext{
    bottom: 5%;
    right: 10%;

  }
  .boutonlast{
    bottom: 5%;
    left: 10%;

  }
  .interview{
    & .logosection{
      padding-top: 18%;
    }
    & .contentsection{
      & .titresection{
        font-family:Marketdeco;
        color: red;
        font-size: 30px;
        margin-bottom: 50px;
        margin-top: 50px;
        & span{
          border-style: solid;
          border-width: 3px 0 3px 0;
          border-color: red;
          padding: 5px 10px 5px 10px;
        }
      }
      & .menucontent{
        width: 100%;
        & .menustyle2{
          width:300px;
          margin: 30px auto 20px;
          /*line-height:24px;*/
          font-size:26px;
        }
      }
    }
  }
}
@media only screen and (min-width: 768px) and (orientation:landscape) {
  .boutonnext{

    bottom: 5%;
    right: 10%;

  }
  .boutonlast{

    bottom: 5%;
    left: 10%;

  }
  .interview{
    & .logosection{
      padding-top: 10%;
    }
  }
}
@media only screen and (min-width: 961px){

  .boutonnext{

    bottom: 50%;
    right: 10%;

  }
  .boutonlast{

    bottom: 50%;
    left: 10%;

  }
  .interview{
    & .logosection{
      padding-top: 10%;
    }
  }

}
</style>



// WEBPACK FOOTER //
// Interview.vue?1a12f3c2